import api, { apiWrapper } from '../api/axios';

export const getVehicleExpenses = async ({
  status = 'all', vehicle = 0, vehicles = "",
  month=0, year=0, branch=0,
  page = 1, pageSize = 20, paginate = true
}) => {
  let params = {
    status,
    month,
    year,
    branch,
    page,
    page_size: pageSize,
    paginate
  };
  if (vehicles) {
    params.vehicles = vehicles;
  } else {
    params.vehicle = vehicle;
  }
  return apiWrapper(() => api.get(`/vehicle/expenses/`, { params }));
};

export const getExpenseApprovals = async ({
  vehicle = 0,
  month=0, year=0,
  page = 1, pageSize = 20
}) => {
  let params = {
    status: "pending",
    vehicle,
    month,
    year,
    page,
    page_size: pageSize,
    paginate: true
  };
  return apiWrapper(() => api.get(`/vehicle/expenses/`, { params }));
};

export const addExpense = async (data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.post("/vehicle/expenses/", formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateVehicleExpensePartial = async (id, data) => {
  const formData = construct_form_data(data);
  return apiWrapper(() => api.patch(`/vehicle/expenses/${id}/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
}

export const approveVehicleExpense = async (id) => {
  return apiWrapper(() => api.post(`/vehicle/expenses/${id}/approve/`));
}

export const rejectVehicleExpense = async (id) => {
  return apiWrapper(() => api.post(`/vehicle/expenses/${id}/reject/`));
}

export const deleteVehicleExpense = async (id) => {
  return apiWrapper(() => api.delete(`/vehicle/expenses/${id}/`));
}

export const exportVehicleExpenses = async ({
  month = 0,
  year = 0,
  branch = 0,
  vehicles = "",
  format = "xls"
}) => {
  let params = { month, year, branch, file_format: format };
  if (vehicles) {
    params = { ...params, vehicles };
  }
  return apiWrapper(() => api.get(`/vehicle/expenses/export/`, { params, responseType: 'blob' }), true, false, true);
};

const construct_form_data = (data) => {

  let form = new FormData();

  // Add text fields
  form = add_field(form, 'expense_type', data?.expense_type);
  form = add_field(form, 'amount', data?.amount);
  form = add_field(form, 'date', data?.date);
  form = add_field(form, 'remarks', data?.remarks);
  form = add_field(form, 'reason', data?.reason);
  form = add_field(form, 'vehicle_id', data?.vehicle);
  form = add_field(form, 'needs_confirmation', data?.needs_confirmation || false);
  
  // Add file fields (make sure these are actual File objects from input type="file")
  form = add_field(form, 'supporting_doc', data?.supporting_doc);

  return form;
};

const add_field = (form, key, value) => {
  if (value) {
    form.append(key, value);
  }
  return form;
};
